import React, { useState } from 'react';
import axios from 'axios';

import $ from 'jquery';
import { toast } from 'react-hot-toast';
import { Card, Col, Form, Row } from 'react-bootstrap';
import CardHeader from '../../components/common/CardHeader';
import LinkButton from '../../components/common/LinkButton';
import {
      FormButton,
      FormImage,
      FormInput,
      FormStatusSelect,
      FormTextarea
} from '../../components/form';

const BannerCreate = () => {
      const [title, setTitle] = useState('');
      const [image, setImage] = useState('');
      const [imageUrl, setImageUrl] = useState('');
      const [subtitle, setSubtitle] = useState('');
      const [summary, setSummary] = useState('');
      const [sloganFirst, setSloganFirst] = useState('');
      const [sloganSecond, setSloganSecond] = useState('');
      const [buttonName, setButtonName] = useState('');
      const [buttonLink, setButtonLink] = useState('');
      const [status, setStatus] = useState('');
      const [loading, setLoading] = useState(false);

      const handleFormSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  title: title,
                  image: image,
                  status: status,
                  subtitle: subtitle,
                  slogan_first: sloganFirst,
                  slogan_second: sloganSecond,
                  summary: summary,
                  banner_link: buttonLink,
                  button_name: buttonName
            };
            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/banners`,
                        data,
                        {
                              headers: {
                                    Authorization: `Bearer ${JSON.parse(
                                          localStorage.getItem('token')
                                    )}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                              $('form').trigger('reset');
                              setImageUrl('');
                        }
                        if (response.data.result === 'error') {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.subtitle) {
                                    toast.error(response.data.message.subtitle);
                              }
                              if (response.data.message.summary) {
                                    toast.error(response.data.message.summary);
                              }
                              if (response.data.message.slogan_first) {
                                    toast.error(
                                          response.data.message.slogan_first
                                    );
                              }
                              if (response.data.message.slogan_second) {
                                    toast.error(
                                          response.data.message.slogan_second
                                    );
                              }
                              if (response.data.message.button_link) {
                                    toast.error(
                                          response.data.message.button_link
                                    );
                              }
                              if (response.data.message.button_name) {
                                    toast.error(
                                          response.data.message.button_name
                                    );
                              }
                              if (response.data.message.image) {
                                    toast.error(response.data.message.image);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleFormSubmit}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader title="Create New Banner">
                                                <LinkButton
                                                      link="/dashboard/banners"
                                                      title="Back"
                                                />
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormInput
                                                            title="Title"
                                                            required={true}
                                                            classes={8}
                                                            handleChange={
                                                                  setTitle
                                                            }
                                                      />
                                                      <FormStatusSelect
                                                            title="Status"
                                                            classes={4}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Sub Title"
                                                            required={false}
                                                            classes={4}
                                                            handleChange={
                                                                  setSubtitle
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Slogan First"
                                                            required={false}
                                                            classes={4}
                                                            handleChange={
                                                                  setSloganFirst
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Slogan Second"
                                                            required={false}
                                                            classes={4}
                                                            handleChange={
                                                                  setSloganSecond
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Button Name"
                                                            required={false}
                                                            classes={4}
                                                            handleChange={
                                                                  setButtonName
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Banner Link"
                                                            required={false}
                                                            classes={4}
                                                            handleChange={
                                                                  setButtonLink
                                                            }
                                                      />
                                                      <FormTextarea
                                                            title="Summary"
                                                            handleChange={
                                                                  setSummary
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4">
                                          <Card.Body>
                                                <Row>
                                                      <FormImage
                                                            title="Featured Image"
                                                            setImage={setImage}
                                                            setImageUrl={
                                                                  setImageUrl
                                                            }
                                                            required={true}
                                                            imageUrl={imageUrl}
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Col lg={12}>
                                                      <FormButton
                                                            title="Submit"
                                                            loading={loading}
                                                      />
                                                </Col>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default BannerCreate;
